
import { useTranslation } from "react-i18next";
import { RiMotorbikeFill } from "react-icons/ri";
import DeliveryAreaSelector from "../DeliveryAreaSelector";
import { Dispatch, SetStateAction } from "react";

interface DeliveryAreaSelectorProps {
    enabled: boolean;
    setEnabled: Dispatch<SetStateAction<boolean>>;
    radius: number;
    setRadius: Dispatch<SetStateAction<number>>;
    price: string;
    setPrice: Dispatch<SetStateAction<string>>;
    selectedLocation: google.maps.LatLngLiteral;
    setSelectedLocation: Dispatch<SetStateAction<google.maps.LatLngLiteral>>;
    selectedPolygon: google.maps.LatLngLiteral[] | null;
    setSelectedPolygon: Dispatch<SetStateAction<google.maps.LatLngLiteral[] | null>>;
    locationUrl: string | null;
    setLocationUrl: Dispatch<SetStateAction<string | null>>;
}


export default function DeliverySettings({
    enabled,
    setEnabled,
    radius,
    setRadius,
    price,
    setPrice,
    selectedLocation,
    setSelectedLocation,
    selectedPolygon,
    setSelectedPolygon,
    locationUrl,
    setLocationUrl,
}: DeliveryAreaSelectorProps) {
    const { t } = useTranslation();

    return (
        <div className="space-y-4">
            {/* Toggle */}
            <label
                dir="ltr"
                className="flex flex-row-reverse items-center gap-4 w-fit select-none"
            >
                <span className="text-base font-medium">
                    {enabled ? t("delivery.enable") : t("delivery.disable")}
                </span>
                <div
                    onClick={() => setEnabled(!enabled)}
                    className={`w-16 h-9 flex cursor-pointer items-center rounded-full p-1 transition-colors duration-300 ${enabled ? "bg-green-500" : "bg-gray-400"
                        }`}
                >
                    <div
                        className={`w-7 h-7 flex items-center justify-center bg-white rounded-full shadow-md transform transition-transform duration-300 ${enabled ? "translate-x-7" : "translate-x-0"
                            }`}
                    >
                        <RiMotorbikeFill
                            size={18}
                            className={`${enabled ? "text-green-600" : "text-gray-500"}`}
                        />
                    </div>
                </div>
            </label>

            {/* Delivery Settings */}
            {enabled && (
                <div className="space-y-4 w-full">
                    {/* Delivery Fee */}
                    <div>
                        <label className="block text-sm font-medium mb-1">
                            {t("delivery.deliveryFee")}
                        </label>
                        <input
                            required
                            type="number"
                            min={0}
                            className={`mt-1 w-full rounded-md border border-gray-300 p-2 focus:outline-none focus:ring-2 focus:ring-border `}
                            placeholder={t("delivery.deliveryFeePlaceholder")}
                            value={price}
                            onChange={(e) => setPrice(e.target.value)}
                        />
                    </div>

                    {/* Delivery Area Selector */}
                    <DeliveryAreaSelector
                        locationUrl={locationUrl}
                        setLocationUrl={setLocationUrl}
                        enabled={enabled}
                        radius={radius}
                        setRadius={setRadius}
                        selectedLocation={selectedLocation}
                        setSelectedLocation={setSelectedLocation}
                        selectedPolygon={selectedPolygon}
                        setSelectedPolygon={setSelectedPolygon}
                    />
                </div>
            )}
        </div>
    );
}
